import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      function createAnimation( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
        if ( window.hasMotion ) {
          if ( ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) || ( typeof elements === 'object' && elements.length > 0 ) ) {
            gsap.set( elements, startAnimationObj );

            const triggers = ScrollTrigger.batch( elements, {
              toggleClass: 'js-animated',
              once: true,
              start: start,
              onEnter: ( batch ) => {
                animationFunction( batch );
              },
            } );

            ScrollTrigger.addEventListener( 'refreshInit', () => {
              triggers.forEach( ( trigger ) => {
                if ( trigger.progress > 0 ) {
                  animationFunction( trigger.trigger );
                }
              } );
            } );
          }
        }
      }

      // global animations in animate will load in after running common.js init function, all component javascript, and before common.js finalize function.
      // This should improve animations loading in and fix odd start times due to load order
      /*
       * Fade on scroll
       */
      const fadeUpClasses = '.js-fade:not(.js-ignore), .js-fade-group > *:not(.js-ignore)';
      function fadeUpTimeline( elements ) {
        const tl = gsap.timeline();
        /*
          * The following .to functions are the equivalent of
          * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
          */

        /* Opacity style and transitions */
        tl.to( elements, {
          opacity: 1, // property/value
          duration: 0.35, // duration e.g. 0.35s
          ease: '0.25,0.1,0.25,1', // timing function e.g. ease
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );

        /* Transform style and transitions */
        tl.to( elements, {
          y: 0, // property/value
          duration: 1, // duration e.g. 1s
          ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }
      createAnimation( fadeUpClasses, {opacity: 0, y: 25}, fadeUpTimeline );

      /*
       * Reveal on scroll
       */
      function reveal( elements ) {
        gsap.to( elements,
            {
              clipPath: 'inset(0% 0% 0% 0%)',
              duration: 1.5,
              ease: '0, 0, 0.58, 1.0',
              stagger: 0.2, // delay e.g 0.2s
            },
        );
      }

      const revealRightClasses = '.js-reveal-right:not(.js-ignore)';
      createAnimation( revealRightClasses, {clipPath: 'inset(0 100% 0 0)'}, reveal );

      const revealLeftClasses = '.js-reveal-left:not(.js-ignore)';
      createAnimation( revealLeftClasses, {clipPath: 'inset(0 0 0 100%)'}, reveal );

      // add active class for css animations
      $( '.activate' ).each( function() {
        ScrollTrigger.create( {
          trigger: this,
          start: 'top 50%',
          scrub: 0.15,
          onRefresh: ( self ) => {
            if ( self.progress > 0 ) {
              $( this ).addClass( 'active' );
            }
          },
          onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'active' ),
        } );
      } );
      document.querySelectorAll( '.border-boxes' ).forEach( ( el ) => {
        const trigger = el;
        ScrollTrigger.create( {
          trigger: el,
          // markers: true,
          start: 'top 60%',
          scrub: 0.15,
          onRefresh: ( self ) => {
            if ( self.progress > 0 ) {
              $( trigger ).addClass( 'js-animated' );
            }
          },
          onEnter: ( {progress, direction, isActive} ) => $( trigger ).addClass( 'js-animated' ),
        } );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
